import request from '@/utils/request';

export default function getHonourList(params, silentRequest = false) {
  return request({
    url: 'About/honour',
    params,
    silentRequest,
  });
}
